import { type IntlShape } from 'react-intl';

import { CohortBuilderModalLegacy } from '@verantos-dev/types-cohorts';

import { CohortBuilderActionDialogType } from '../contexts/CohortBuilderModalContext';

export const getCohortEditModalTitle = (
  intl: IntlShape,
  activeDialog: CohortBuilderModalLegacy | CohortBuilderActionDialogType | null,
  isEditable: boolean
) => {
  switch (activeDialog) {
    case CohortBuilderModalLegacy.ADD_SIMPLE_EVENT:
      return intl.formatMessage({
        id: 'projects.cohortBuilderPage.simpleEventsEditModal.createMode.title',
      });
    case CohortBuilderModalLegacy.EDIT_SIMPLE_EVENT:
      return isEditable
        ? intl.formatMessage({
            id: 'projects.cohortBuilderPage.simpleEventsEditModal.editMode.title',
          })
        : intl.formatMessage({
            id: 'projects.cohortBuilderPage.simpleEventsEditModal.viewMode.title',
          });
    // case CohortBuilderActionDialogType.DELETE_SIMPLE_EVENT:
    //   return intl.formatMessage({
    //     id: 'projects.cohortBuilderPage.simpleEventsDeleteModal.title',
    //   });
    case CohortBuilderModalLegacy.ADD_DERIVED_EVENT:
      return intl.formatMessage({
        id: 'projects.cohortBuilderPage.derivedEventsEditModal.createMode.title',
      });
    case CohortBuilderModalLegacy.EDIT_DERIVED_EVENT:
      return isEditable
        ? intl.formatMessage({
            id: 'projects.cohortBuilderPage.derivedEventsEditModal.editMode.title',
          })
        : intl.formatMessage({
            id: 'projects.cohortBuilderPage.derivedEventsEditModal.viewMode.title',
          });
    // case CohortBuilderActionDialogType.DELETE_DERIVED_EVENT:
    //   return intl.formatMessage({
    //     id: 'projects.cohortBuilderPage.derivedEventsDeleteModal.title',
    //   });
    case CohortBuilderModalLegacy.ADD_SUBJECT_VARIABLE:
      return intl.formatMessage({
        id: 'projects.cohortBuilderPage.subjectVariableEditCard.titleAdd',
      });
    case CohortBuilderModalLegacy.EDIT_SUBJECT_VARIABLE:
      return isEditable
        ? intl.formatMessage({
            id: 'projects.cohortBuilderPage.subjectVariableEditCard.titleEdit',
          })
        : intl.formatMessage({
            id: 'projects.cohortBuilderPage.subjectVariableEditCard.titleView',
          });
    // case CohortBuilderActionDialogType.DELETE_SUBJECT_VARIABLE:
    //   return intl.formatMessage({
    //     id: 'projects.cohortBuilderPage.subjectVariableDeleteModal.title',
    //   });

    // case CohortBuilderActionDialogType.DELETE_INDEX_DATE:
    //   return intl.formatMessage({
    //     id: 'projects.cohortBuilderPage.indexDateDeleteModal.title',
    //   });

    case CohortBuilderActionDialogType.PROCESS_COHORT_DEFINITION:
      return intl.formatMessage({
        id: 'projects.cohortBuilderPage.processCohortDefinitionModal.title',
      });

    case CohortBuilderActionDialogType.SAVE_COHORT_DEFINITION:
      return intl.formatMessage({
        id: 'projects.cohortBuilderPage.saveCohortDefinitionModal.title',
      });

    default:
      return '';
  }
};
